import {
    DeviceId, DeviceTemplateId, ProviderDeviceReference, ProjectId, ProviderType,
    DeviceSlotId
} from "../ids";
import {Ticket} from "../ticket";
import {DevicePropertyNames} from "@webmate-web-core/shared/types/devices/device-properties";
import {Platform, platformFromString} from '@webmate-web-core/shared/types/platform';

export class  Device {
    constructor(public id: DeviceId,
                public state: string,
                public creationTime: Date /* TODO a own date class?*/,
                public name: string, //in front-end all Devices have a name
                public request: any /* TODO maybe own class? after all, we will send these things ourselves*/,
                public properties: any,
                public projectId: ProjectId,
                public creationTicket: Ticket,
                public tickets: Array<Ticket>,
                public lastUpdate: Date,
                public platform: Platform, //front-end only
                public slot: DeviceSlotId,
                //the optional values
                public niceState?: string, //front-end only
    ) {}

    public isAvailableToJobs(): boolean {
        return this.properties[DevicePropertyNames.AutomationAvailable] === true;
    }

    public isHeadlessDevice(): boolean {
        return this.properties[DevicePropertyNames.ProviderType] === "headless"
    }
}

/** helper function to make front-end specific modification to Devices */
export function deviceFromBackendObject(d: any): Device {
    if (d.name === undefined || d.name.length <= 0) {
        d.name = d.creationTicket?.job?.name !== "DeviceSession" ? "[Automated Test]" : "Unnamed Device"; //front-end always names Devices, no matter what the BackEnd says
    }
    d.platform = platformFromString(d.properties[DevicePropertyNames.MachinePlatform] || 'UNKNOWN_0_0');
    switch (d.properties[DevicePropertyNames.VCloudState]) {
        case "deploying":
        case "poweringon":
            d['niceState'] = "provisioning";
            break;
        case "poweringoff":
            d['niceState'] = "shutting down";
            break;
        case "snapshoting":
            d['niceState'] = "taking snapshot";
            break;
        case "revertingtosnapshot":
            d['niceState'] = "reverting to snapshot";
            break;
        case "revertingtotemplate":
            d['niceState'] = "reverting to template";
            break;
        case "shallbedeleted":
            d['niceState'] = "scheduled for deletion";
            break;
        case "off":
            d['niceState'] = "powered down";
            break;
        case "orphan":
            d['niceState'] = "ERROR - orphaned";
            break;
        default:
            if(d.state ==='running' && (d.properties[DevicePropertyNames.SetupDone] === undefined
                || d.properties[DevicePropertyNames.SetupDone] === false)){
                d['niceState'] = "running (initializing)"
            }
            else {
                d['niceState'] = d.state;
            }
    }

    return new Device(
        d.id,
        d.state,
        new Date(d.creationTime),
        d.name,
        d.request,
        d.properties,
        d.projectId,
        d.creationTicket,
        d.tickets,
        d.lastUpdate,
        d.platform,
        d.slot,
        d.niceState
    );
}

export function deviceSortingFunction(a: Device, b: Device): number {
    if (a.name === b.name /* check the name next*/) {
        if (!!a.creationTime && !!b.creationTime) {
            return a.creationTime.getTime() -  b.creationTime.getTime();
        } else {
            return 0;
        }
    } else {
        if (!!a.name) {
            return a.name.localeCompare(b.name);
        } else {
            return -1;
        }
    }
}

// A DevTools endpoint represents a debugging endpoint (e.g., Chrome DevTools) exposed by a device.
export interface DevToolsEndpoint {
    id: string;
    endpointType: string;
    title?: string;
    devicePort: number;
    frontendType?: 'chromium' | 'webkit';
}
